import React from "react"
import { useReportFormInfo } from "Pages/ReportsAlerts/Reports/@hooks"
import { reportFormData } from "Pages/ReportsAlerts/Reports/@signals"
import { array, object } from "yup"
import { AppPriceComparisonAlertAutocomplete } from "@components/Autocomplete"


export default function ReportPriceComparisonAlertField() {
	const {
		conditionsPriceComparison,
		setConditionsPriceComparisonInfo,
		error
	} = useReportFormInfo(reportFormData.peek().conditionsPriceComparison || [], "conditionsPriceComparison", object({ conditionsPriceComparison: array().nullable() }))

	return <AppPriceComparisonAlertAutocomplete
		multiple
		value={conditionsPriceComparison}
		onChange={e => setConditionsPriceComparisonInfo(e.target.value)}
		error={error}
	/>
}